// Mock data for TicketsPro.app clone (frontend-only). Images reference original public assets.

export const navLinks = [
  { label: "Why us?", hasDropdown: true, children: ["The platform", "Our story", "Security", "Pricing"] },
  { label: "Solutions", hasDropdown: true, children: ["Hotels", "Restaurants", "Spas", "Attractions", "Groups"] },
  { label: "Integrations", hasDropdown: true, children: ["POS systems", "CRM & email", "Payments", "Analytics"] },
  { label: "Clients", hasDropdown: false },
  { label: "Resources", hasDropdown: true, children: ["Blog", "Guides", "Webinars", "Help centre"] },
  { label: "Contact", hasDropdown: false },
];

export const clientLogos = [
  { name: "Young's", src: "https://giftpro.co.uk/wp-content/uploads/2025/08/youngs-logo-small.webp" },
  { name: "The PIG", src: "https://giftpro.co.uk/wp-content/uploads/2025/08/pig-logo-small.webp" },
  { name: "Searcys", src: "https://giftpro.co.uk/wp-content/uploads/2025/08/searcys-logo-small.webp" },
  { name: "Hilton", src: "https://giftpro.co.uk/wp-content/uploads/2025/08/hilton-logo-small.webp" },
  { name: "Limewood", src: "https://giftpro.co.uk/wp-content/uploads/2025/08/limewood-logo-small.webp" },
  { name: "Ottolenghi", src: "https://giftpro.co.uk/wp-content/uploads/2025/08/ottolenghi-logo-small.webp" },
  { name: "Vale Resort", src: "https://giftpro.co.uk/wp-content/uploads/2025/08/vale-logo-small.webp" },
  { name: "Hakkasan", src: "https://giftpro.co.uk/wp-content/uploads/2025/08/hakkasan-logo-small.webp" },
  { name: "Galvin", src: "https://giftpro.co.uk/wp-content/uploads/2025/08/galvin-logo-small.webp" },
  { name: "Heckfield", src: "https://giftpro.co.uk/wp-content/uploads/2025/08/heckfield-logo-small.webp" },
  { name: "Caprice", src: "https://giftpro.co.uk/wp-content/uploads/2025/08/caprice-logo-white-small.webp" },
  { name: "OXO", src: "https://giftpro.co.uk/wp-content/uploads/2025/08/oxo-logo-small.webp" },
  { name: "Puttshack", src: "https://giftpro.co.uk/wp-content/uploads/2025/08/puttshack-logo-small.webp" },
  { name: "Four Seasons", src: "https://giftpro.co.uk/wp-content/uploads/2025/08/four-seasons-logo-small.webp" },
  { name: "Careys Manor", src: "https://giftpro.co.uk/wp-content/uploads/2025/08/careys-manor-logo-small.webp" },
  { name: "Roka", src: "https://giftpro.co.uk/wp-content/uploads/2025/08/roka-logo-small.webp" },
  { name: "Pizza Pilgrims", src: "https://giftpro.co.uk/wp-content/uploads/2025/08/pizza-pilgrims-logo-small.webp" },
  { name: "Aqua", src: "https://giftpro.co.uk/wp-content/uploads/2025/08/aqua-logo-small.webp" },
];

export const storeSlides = [
  { name: "Searcys", src: "https://giftpro.co.uk/wp-content/uploads/2025/09/Searcys-listing-page.webp" },
  { name: "The PIG", src: "https://giftpro.co.uk/wp-content/uploads/2025/09/the-pig-listing-page.webp" },
  { name: "The Vale Resort", src: "https://giftpro.co.uk/wp-content/uploads/2025/09/The-Vale-resort-listing-page.webp" },
  { name: "Hakkasan", src: "https://giftpro.co.uk/wp-content/uploads/2025/09/Hakkasan-listing-page.webp" },
  { name: "Heckfield", src: "https://giftpro.co.uk/wp-content/uploads/2025/09/Heckfield-listing-page.webp" },
];

export const adminStats = [
  { label: "Today", value: "£586.50" },
  { label: "This month", value: "£12,490.56" },
  { label: "This year", value: "£109,653.22" },
];

export const packaging = [
  { name: "Oxford St gift wallet", src: "https://giftpro.co.uk/media/images/packaging/wallet-oxford_st-2369w.jpg" },
  { name: "Ideal Collection gift card", src: "https://giftpro.co.uk/media/images/packaging/card-ideal_collection-1476w.png" },
  { name: "Vine Estate gift box", src: "https://giftpro.co.uk/media/images/packaging/box-vine-estate-2179w.png" },
];

export const integrations = [
  { name: "Campaign Monitor", src: "https://giftpro.co.uk/media/images/partners/campaign_monitor.png" },
  { name: "Dotdigital", src: "https://giftpro.co.uk/media/images/partners/dotdigital.png" },
  { name: "Mailchimp", src: "https://giftpro.co.uk/media/images/partners/mailchimp.png" },
  { name: "Acteol", src: "https://giftpro.co.uk/media/images/partners/acteol.png" },
  { name: "Comtrex", src: "https://giftpro.co.uk/media/images/partners/comtrex.jpg" },
  { name: "MEWS", src: "https://giftpro.co.uk/media/images/partners/mews.png" },
  { name: "Oracle", src: "https://giftpro.co.uk/media/images/partners/oracle.png" },
  { name: "Tevalis", src: "https://giftpro.co.uk/media/images/partners/tevalis.png" },
  { name: "Tissl", src: "https://giftpro.co.uk/media/images/partners/tissl.png" },
  { name: "Facebook", src: "https://giftpro.co.uk/media/images/partners/facebook.png" },
  { name: "Google Analytics", src: "https://giftpro.co.uk/media/images/partners/google_analytics.png" },
  { name: "Instagram", src: "https://giftpro.co.uk/media/images/partners/instagram.png" },
  { name: "Xero", src: "https://giftpro.co.uk/media/images/partners/xero.png" },
  { name: "Alchemetrics", src: "https://giftpro.co.uk/media/images/partners/alchemetrics.png" },
];

export const caseStudies = [
  {
    image: "https://giftpro.co.uk/wp-content/uploads/2025/08/searcys-testimonial.webp",
    stat: "35%",
    statLabel: "increase in average order value",
    quote: "In the first six months, we have seen a conversion rate of 12.7% and an average order value increase of 35%, which is above the industry average.",
    logo: "https://giftpro.co.uk/wp-content/uploads/2025/08/searcys-logo-small.webp",
    name: "Anna Fenten",
    role: "Head of Brand & Marketing",
  },
  {
    image: "https://giftpro.co.uk/wp-content/uploads/2025/08/vale-resort-view.webp",
    stat: "57%",
    statLabel: "increase in sales",
    quote: "We switched to TicketsPro.app 6 months ago and since then we’ve seen a huge 57% increase in sales compared to last year.",
    logo: "https://giftpro.co.uk/wp-content/uploads/2020/10/vale-logo-white.png",
    name: "Stephanie Metson",
    role: "Marketing Manager",
  },
  {
    image: "https://giftpro.co.uk/wp-content/uploads/2025/08/youngs-gift-voucher.webp",
    stat: "100%",
    statLabel: "increase in gift voucher sales",
    quote: "The support we have received from James and the team since partnering with TicketsPro.app has been amazing, from strategic ideas to the creation of over 50 local stores.",
    logo: "https://giftpro.co.uk/wp-content/uploads/2025/08/youngs-logo-small.webp",
    name: "Sarah May Groves",
    role: "Head of Sales",
  },
];

export const testimonials = {
  lottie: {
    quote: "We were delighted with the level of service and care we received from the TicketsPro.app team during our migration.",
    name: "Lottie Bruce",
    role: "Head of Marketing",
    company: "Limewood",
    avatar: "https://giftpro.co.uk/wp-content/uploads/elementor/thumbs/avatar-lotti_eagles-purple-rcy43ak0wg4g9tachjdngy185oy6go18g4cigc2slo.png",
  },
  hayley: {
    quote: "We were really happy to find TicketsPro.app. The process of launching our online store was seamless, and we received support every step of the way.",
    name: "Hayley Donigan",
    role: "Marketing Executive",
    company: "OXO Tower",
    avatar: "https://giftpro.co.uk/wp-content/uploads/elementor/thumbs/avatar-hayley_donigan-cyan-rcy43ak0wg4g9tachjdngy185oy6go18g4cigc2sm8.png",
  },
};

export const blogPosts = [
  {
    tag: "Articles",
    image: "https://giftpro.co.uk/wp-content/uploads/2026/06/CAM2026-045-OUTPUT_TicketsPro.app-Retention_Blog_FATHERS-DAY-768x526.jpg",
    title: "How to turn seasonal gifting moments into revenue",
    excerpt: "Father’s Day has a habit of sneaking up. One minute it’s “weeks away”, the next it’s a frantic search for something that feels thoughtful, personal, and ideally not another pair of novelty socks.",
  },
  {
    tag: "Articles",
    image: "https://giftpro.co.uk/wp-content/uploads/2026/04/CAM2026-082_REZCONTROL_CrossSelltoTicketsPro.app_BlogHeader_02_02-768x526.jpg",
    title: "Unlock more from your gift voucher software with the right hotel PMS",
    excerpt: "Gift vouchers are a proven revenue stream for independent hotels, and the opportunity is growing. According to a 2024 report by the GCVA, gift voucher sales across leisure and hospitality grew by 15.5% like-for-like.",
  },
  {
    tag: "Articles",
    image: "https://giftpro.co.uk/wp-content/uploads/2026/03/CAM2026-082_REZCONTROL_CrossSelltoTicketsPro.app_BlogHeader_01_01-768x526.jpg",
    title: "From chaos to calm: the smarter way to run your independent hotel",
    excerpt: "Running an independent hotel can leave you feeling rushed off your feet. You’re managing bookings, checking in guests, coordinating housekeeping, handling guest queries, and more – often all at once.",
  },
];
